<template>
  <div class="wh100">
    <el-menu
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      :collapse="isCollapse"
      @select="handleSelect"
      style="height: 100%"
    >
      <menu-item
        v-for="item in menuData"
        :key="item[fieldMap.id]"
        :item="item"
        :picon="picon"
        :cicon="cicon"
        :field-map="fieldMap"
        @click="handleClick"
      />
    </el-menu>
  </div>
</template>

<script>
import MenuItem from "./item.vue";

export default {
  name: "TreeMenu",
  components: {
    MenuItem,
  },
  props: {
    active: {
      type: String,
      default: "",
    },
    menuData: {
      type: Array,
      required: true,
      default: () => [],
    },
    picon: {
      type: String,
      default: "el-icon-s-grid",
    },
    cicon: {
      type: String,
      default: "el-icon-menu",
    },
    isCollapse: {
      type: Boolean,
      default: false,
    },
    fieldMap: {
      type: Object,
      default: () => ({
        id: "Id",
        title: "title",
        children: "children",
      }),
    },
  },
  data() {
    return {
      activeIndex: "",
    };
  },
  methods: {
    handleSelect(index) {
      this.activeIndex = index;
      this.$emit("select", index);
    },
    handleClick(item) {
      this.$emit("click", item);
    },
  },
  watch: {
    active(a) {
      this.activeIndex = a;
    },
  },
};
</script>

<style lang="scss" scoped></style>
